require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-05-08-dear-mom.json") })
        }
      }, "path---articles-2007-05-08-dear-mom");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-05-08-dear-mom!./.cache/json/articles-2007-05-08-dear-mom.json
// module id = 511
// module chunks = 231608221292675